/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  CREATE_ISSUE_REQUEST,
  CREATE_ISSUE_SUCCESS,
  CREATE_ISSUE_FAILURE,
  SUPPORT_HOMEPAGE_REQUEST,
  SUPPORT_HOMEPAGE_SUCCESS,
  SUPPORT_HOMEPAGE_FAILURE,
  GET_REQUESTTYPES_REQUEST,
  GET_REQUESTTYPES_SUCCESS,
  GET_REQUESTTYPES_FAILURE,
  GET_ISSUESTATUS_REQUEST,
  GET_ISSUESTATUS_SUCCESS,
  GET_ISSUESTATUS_FAILURE,
  GET_ISSUECOMMENTS_REQUEST,
  GET_ISSUECOMMENTS_SUCCESS,
  GET_ISSUECOMMENTS_FAILURE,
  ADD_ISSUECOMMENTS_REQUEST,
  ADD_ISSUECOMMENTS_SUCCESS,
  ADD_ISSUECOMMENTS_FAILURE,
  REOPENISSUE_REQUEST,
  REOPENISSUE_SUCCESS,
  REOPENISSUE_FAILURE,
  ADD_ATTACHMENTS_REQUEST,
  ADD_ATTACHMENTS_SUCCESS,
  ADD_ATTACHMENTS_FAILURE,
  GET_REPORTED_TICKETS_REQUEST,
  GET_REPORTED_TICKETS_SUCCESS,
  GET_REPORTED_TICKETS_FAILURE,
  CREATE_REPORT_TICKET_REQUEST,
  CREATE_REPORT_TICKET_SUCCESS,
  CREATE_REPORT_TICKET_FAILURE,
  TICKET_HOMEPAGE_REQUEST,
  TICKET_HOMEPAGE_SUCCESS,
  TICKET_HOMEPAGE_FAILURE,
  GET_TICKET_STATUS_REQUEST,
  GET_TICKET_STATUS_SUCCESS,
  GET_TICKET_STATUS_FAILURE,
  GET_TICKET_COMMENTS_REQUEST,
  GET_TICKET_COMMENTS_SUCCESS,
  GET_TICKET_COMMENTS_FAILURE,
  ADD_TICKET_COMMENTS_REQUEST,
  ADD_TICKET_COMMENTS_SUCCESS,
  ADD_TICKET_COMMENTS_FAILURE,
  RE_OPEN_TICKET_REQUEST,
  RE_OPEN_TICKET_SUCCESS,
  RE_OPEN_TICKET_FAILURE,
  GET_COMPLETED_TICKETS_REQUEST,
  GET_COMPLETED_TICKETS_SUCCESS,
  GET_COMPLETED_TICKETS_FAILURE,
  GET_TICKETS_COUNTS_REQUEST,
  GET_TICKETS_COUNTS_SUCCESS,
  GET_TICKETS_COUNTS_FAILURE,
  GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST,
  GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS,
  GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE,
  GET_TICKET_DETAILS_REQUEST,
  GET_TICKET_DETAILS_SUCCESS,
  GET_TICKET_DETAILS_FAILURE,
} from "./ticketsTypes";
import Cookies from "universal-cookie";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();
const userData = cookies.get("loginDetailsForSupport");

const getReportedTicketsRequest = () => {
  return {
    type: GET_REPORTED_TICKETS_REQUEST,
  };
};

const getReportedTicketsSuccess = (payload) => {
  return {
    type: GET_REPORTED_TICKETS_SUCCESS,
    payload: payload,
  };
};

const getReportedTicketsFaliure = (error) => {
  return {
    type: GET_REPORTED_TICKETS_FAILURE,
    payload: error,
  };
};

const getReportedTickets = ( token,payload) => {
  return (dispatch) => {
    dispatch(getReportedTicketsRequest());
    let url = `${baseUrl}/jira/requests/requests_by_reporter`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(url, payload,config)
      .then((response) => {
        console.log("response",response)
        dispatch(getReportedTicketsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getReportedTicketsFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const createTicketRequest = () => {
  return {
    type: CREATE_REPORT_TICKET_REQUEST,
  };
};

const createTicketSuccess = (payload) => {
  return {
    type: CREATE_REPORT_TICKET_SUCCESS,
    payload: payload,
  };
};

const createTicketFaliure = (error) => {
  return {
    type: CREATE_REPORT_TICKET_FAILURE,
    payload: error,
  };
};

const createTicket = (payload, token) => {
  return (dispatch) => {
    dispatch(createTicketRequest());
    let url = `${baseUrl}/jira/requests`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(createTicketSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTicketFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const addAttachmentsRequest = () => {
  return {
    type: ADD_ATTACHMENTS_REQUEST,
  };
};

const addAttachmentsSuccess = (payload) => {
  return {
    type: ADD_ATTACHMENTS_SUCCESS,
    payload: payload,
  };
};

const addAttachmentsFaliure = (error) => {
  return {
    type: ADD_ATTACHMENTS_FAILURE,
    payload: error,
  };
};

const addAttachments = (payload, token) => {
  return (dispatch) => {
    dispatch(addAttachmentsRequest());
    let url = `${baseUrl}/jira/requests/add_attachments`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(addAttachmentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(addAttachmentsFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const getRequestTypesRequest = () => {
  return {
    type: GET_REQUESTTYPES_REQUEST,
  };
};

const getRequestTypesSuccess = (payload) => {
  return {
    type: GET_REQUESTTYPES_SUCCESS,
    payload: payload,
  };
};

const getRequestTypesFaliure = (error) => {
  return {
    type: GET_REQUESTTYPES_FAILURE,
    payload: error,
  };
};

const getRequestTypes = (token) => {
  return (dispatch) => {
    dispatch(getRequestTypesRequest());
    let url = `${baseUrl}/jira/requests/requesttypes?desk_id=${serviceDeskId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getRequestTypesSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getRequestTypesFaliure(err.message));
      });
  };
};

const ticketHomePageRequest = () => {
  return {
    type: TICKET_HOMEPAGE_REQUEST,
  };
};

const ticketHomePageSuccess = (payload) => {
  return {
    type: TICKET_HOMEPAGE_SUCCESS,
    payload: payload,
  };
};

const ticketHomePageFaliure = (error) => {
  return {
    type: TICKET_HOMEPAGE_FAILURE,
    payload: error,
  };
};

const ticketHomePage = (payload, token) => {
  return (dispatch) => {
    dispatch(ticketHomePageRequest());
    let url = `${baseUrl}/jira/requests/requests_count`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(ticketHomePageSuccess(response.data));
      })
      .catch((err) => {
        dispatch(ticketHomePageFaliure(err.message));
      });
  };
};

const getTicketStatusRequest = () => {
  return {
    type: GET_TICKET_STATUS_REQUEST,
  };
};

const getTicketStatusSuccess = (payload) => {
  return {
    type: GET_TICKET_STATUS_SUCCESS,
    payload: payload,
  };
};

const getTicketStatusFaliure = (error) => {
  return {
    type: GET_TICKET_STATUS_FAILURE,
    payload: error,
  };
};
// const getTicketStatus = (id, token) => {
//   return (dispatch) => {
//     dispatch(getTicketStatusRequest());
//     let url = `${baseUrl}/jira/requests/request_by_id?issue_id=${id}`;
//     let config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };
//     axios
//       .get(url, config)
//       .then((response) => {
//         dispatch(getTicketStatusSuccess(response.data.data));
//       })
//       .catch((err) => {
//         dispatch(getTicketStatusFaliure(err.message));
//       });
//   };
// };

const getTicketStatus = ( token,payload) => {
  return (dispatch) => {
    dispatch(getTicketStatusRequest());
    let url = `${baseUrl}/jira/requests/requests_by_reporter`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(url, payload,config)
      .then((response) => {
        console.log("response",response)
        dispatch(getTicketStatusSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getTicketStatusFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};


const getCompletedTicketsRequest = () => {
  return {
    type: GET_COMPLETED_TICKETS_REQUEST,
  };
};

const getCompletedTicketsSuccess = (payload) => {
  return {
    type: GET_COMPLETED_TICKETS_SUCCESS,
    payload: payload,
  };
};

const getCompletedTicketsFaliure = (error) => {
  return {
    type: GET_COMPLETED_TICKETS_FAILURE,
    payload: error,
  };
};

// const getCompletedTickets = (clientId, token) => {
//   return (dispatch) => {
//     dispatch(getCompletedTicketsRequest());
//     let url = `${baseUrl}/jira/requests/get_issues_by_clientId?clientId=${clientId}&status=Completed`;
//     let config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };
//     axios
//       .get(url, config)
//       .then((response) => {
//         dispatch(getCompletedTicketsSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getCompletedTicketsFaliure(err.message));
//       });
//   };
// };
const getCompletedTickets = ( token,payload) => {
  return (dispatch) => {
    dispatch(getCompletedTicketsRequest());
    let url = `${baseUrl}/jira/requests/requests_by_reporter`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(url, payload,config)
      .then((response) => {
        console.log("response",response)
        dispatch(getCompletedTicketsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getCompletedTicketsFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const getTicketCommentsRequest = () => {
  return {
    type: GET_TICKET_COMMENTS_REQUEST,
  };
};

const getTicketCommentsSuccess = (payload) => {
  return {
    type: GET_TICKET_COMMENTS_SUCCESS,
    payload: payload,
  };
};

const getTicketCommentsFaliure = (error) => {
  return {
    type: GET_TICKET_COMMENTS_FAILURE,
    payload: error,
  };
};

const getTicketComments = (id, email, token) => {
  return (dispatch) => {
    dispatch(getTicketCommentsRequest());
    let url = `${baseUrl}/jira/requests/comments?issue_id=${id}&email=${email}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketCommentsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketCommentsFaliure(err.message));
      });
  };
};

const addTicketCommentRequest = () => {
  return {
    type: ADD_TICKET_COMMENTS_REQUEST,
  };
};

const addTicketCommentSuccess = (payload) => {
  return {
    type: ADD_TICKET_COMMENTS_SUCCESS,
    payload: payload,
  };
};

const addTicketCommentFaliure = (error) => {
  return {
    type: ADD_TICKET_COMMENTS_FAILURE,
    payload: error,
  };
};

const addTicketComment = (payload, token) => {
  return (dispatch) => {
    dispatch(addTicketCommentRequest());
    let url = `${baseUrl}/jira/requests/add_comment`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(addTicketCommentSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(addTicketCommentFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const reopenTicketRequest = () => {
  return {
    type: RE_OPEN_TICKET_REQUEST,
  };
};

const reopenTicketSuccess = (payload) => {
  return {
    type: RE_OPEN_TICKET_SUCCESS,
    payload: payload,
  };
};

const reopenTicketFailure = (error) => {
  return {
    type: RE_OPEN_TICKET_FAILURE,
    payload: error,
  };
};

const reopenTicket = (payload, token) => {
  return (dispatch) => {
    dispatch(reopenTicketRequest());
    let url = `${baseUrl}/jira/requests/reopen_ticket`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .put(url, payload, config)
      .then((response) => {
        dispatch(reopenTicketSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(reopenTicketFailure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const getTicketsByStatusForCompletedRequest = () => {
  return {
    type: GET_TICKETS_COUNTS_REQUEST,
  };
};

const getTicketsByStatusForCompletedSuccess = (payload) => {
  return {
    type: GET_TICKETS_COUNTS_SUCCESS,
    payload: payload,
  };
};

const getTicketsByStatusForCompletedFaliure = (error) => {
  return {
    type: GET_TICKETS_COUNTS_FAILURE,
    payload: error,
  };
};

const getTicketsByStatusForCompleted = (token) => {
  return (dispatch) => {
    dispatch(getTicketsByStatusForCompletedRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count?status=Completed`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketsByStatusForCompletedSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketsByStatusForCompletedFaliure(err.message));
      });
  };
};

const getTicketsByStatusForActiveRequest = () => {
  return {
    type: GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST,
  };
};

const getTicketsByStatusForActiveSuccess = (payload) => {
  return {
    type: GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS,
    payload: payload,
  };
};

const getTicketsByStatusForActiveFaliure = (error) => {
  return {
    type: GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE,
    payload: error,
  };
};

const getTicketsByStatusForActive = (token) => {
  return (dispatch) => {
    dispatch(getTicketsByStatusForActiveRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count?status=Active`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketsByStatusForActiveSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketsByStatusForActiveFaliure(err.message));
      });
  };
};

const getHomeTicketDetailsRequest = () => {
  return {
    type: GET_TICKET_DETAILS_REQUEST,
  };
};

const getHomeTicketDetailsSuccess = (payload) => {
  return {
    type: GET_TICKET_DETAILS_SUCCESS,
    payload: payload,
  };
};

const getHomeTicketDetailsFaliure = (error) => {
  return {
    type: GET_TICKET_DETAILS_FAILURE,
    payload: error,
  };
};

const getHomeTicketDetails = (clientId, token) => {
  return (dispatch) => {
    dispatch(getHomeTicketDetailsRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count?clientId=${clientId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getHomeTicketDetailsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getHomeTicketDetailsFaliure(err.message));
      });
  };
};

export {
  getReportedTickets,
  createTicket,
  getRequestTypes,
  ticketHomePage,
  getTicketStatus,
  getTicketComments,
  addTicketComment,
  reopenTicket,
  addAttachments,
  getCompletedTickets,
  getTicketsByStatusForCompleted,
  getTicketsByStatusForActive,
  getHomeTicketDetails,
};
